const productIdOf = product =>
  String(product?._id || product?.id || product?.productId || '').trim()

const savedConversion = mapping => {
  if (!mapping || mapping.useBaseUoM) return null
  const conversionId = String(mapping.selectedConversionId || '').trim()
  if (!conversionId) return null
  return {
    conversionId,
    label: String(mapping.selectedConversionLabel || 'Conversion').trim(),
    toUnit: String(mapping.selectedToUnit || '').trim(),
    toQty: Number(mapping.selectedToQty) || 0,
  }
}

/**
 * Profiles keep the stock lines that were chosen, which may be from an
 * older count than the list on screen. Those lines still need a name and
 * the mapping that was already saved.
 */
export const productsForLinkedProfileEdit = (products, groups) => {
  const byId = new Map()
  ;(products || []).forEach(product => {
    const id = productIdOf(product)
    if (id) byId.set(id, product)
  })
  ;(groups || []).forEach(group => {
    const mappings = new Map(
      (Array.isArray(group?.memberMappings) ? group.memberMappings : []).map(
        mapping => [String(mapping?.productId || '').trim(), mapping],
      ),
    )
    ;(Array.isArray(group?.linkedProducts) ? group.linkedProducts : []).forEach(
      snapshot => {
        const id = productIdOf(snapshot)
        if (!id || byId.has(id)) return
        const conversion = savedConversion(mappings.get(id))
        byId.set(id, {
          ...snapshot,
          _id: id,
          conversions: conversion ? [conversion] : [],
        })
      },
    )
  })

  return [...byId.values()]
}
